import { GetBannerAPI, AddBannerAPI, GetBannerDetailAPI, PutBannerAPI, DelBannerAPI } from '@/api/banner'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取banner
    async  getbanner({ commit }, item) {
      const res = await GetBannerAPI(item)
      return res
    },
    // 添加banner
    async addBanner({ commit }, item) {
      await AddBannerAPI(item)
    },
    // 获取banner详情
    async getbannerdetail({ commit }, id) {
      const res = await GetBannerDetailAPI(id)
      return res
    },
    // 更新banner详情
    async putbanner({ commit }, item) {
      await PutBannerAPI(item)
    },
    // 删除banner
    async delbanner({ commit }, id) {
      await DelBannerAPI(id)
    }

  }
}
